import axios from 'axios'
import { CheckPromoReferralCodeResponse } from 'types/bolt-api/request'

/**
 * Checks if the given promo/referral code is valid & returns its details
 *
 * @param {string} code
 * @returns {Promise<CheckPromoReferralCodeResponse>}
 */
const checkPromoReferralCode = async (code: string): Promise<CheckPromoReferralCodeResponse> => {
  try {
    const { data } = await axios.get<CheckPromoReferralCodeResponse>(`${process.env.API_URL}/website/promo-referral-code?code=${code}`, {
      headers: {
        Authorization: `Basic ${process.env.API_TOKEN}`
      }
    })

    return data
  } catch (_) {
    return { valid: false }
  }
}

export default checkPromoReferralCode
